import { AltaPay } from '~/services/altapay/types';
import { PaymentMethod } from '~/shared/constants';

export type AltaPayPaymentOption = AltaPay.Schemas['PaymentMethod'];
export type NetsPaymentOption = {
    id: PaymentMethod.NETS;
    name: string;
};

export type SelectablePaymentOption = AltaPayPaymentOption | NetsPaymentOption;

export const isNetsPaymentOption = (option: SelectablePaymentOption): option is NetsPaymentOption =>
    option.id === PaymentMethod.NETS;

export const isAltaPayPaymentOption = (
    option: SelectablePaymentOption,
): option is AltaPayPaymentOption =>
    !!(option as AltaPayPaymentOption).id && !!(option as AltaPayPaymentOption).type;

export const isAltaPayCreditCardPayment = (option: SelectablePaymentOption) =>
    isAltaPayPaymentOption(option) &&
    (option.name === 'Credit / Debit Card' || option.type === 'CARD');

export const isAltaPayKlarnaPayment = (option: SelectablePaymentOption) =>
    isAltaPayPaymentOption(option) && option.name === 'Klarna' && option.type === 'INVOICE';

export const isAltaPayScriptPayment = (option: SelectablePaymentOption) =>
    isAltaPayCreditCardPayment(option) || isAltaPayKlarnaPayment(option);

export const isAltaPayApplePay = (option: SelectablePaymentOption | undefined) =>
    !!option &&
    isAltaPayPaymentOption(option) &&
    option.type === 'WALLET' &&
    (option.name === 'ApplePay' || option.jsMethodHandler?.identifier === 'ApplePay');

export const isAltaPayMobilePay = (option: SelectablePaymentOption) =>
    isAltaPayPaymentOption(option) && option.name === 'MobilePay' && option.type === 'WALLET';
